/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { MessageBarType, Pivot, PivotItem, PrimaryButton, MessageBar } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import SelectCobrandsForm from '../../CoBrandSettings/HubSettings/Forms/SelectCobrandsForm';
import ShowCobrandList from '../../CoBrandSettings/HubSettings/ShowCobrandList';
import Courses from './Courses';
import Tools from './Tools';
import Tags from './Tags';
import Content from './Content';
import Series from './Series';
import FinancialMindfulness from './FinancialMindfulness';
import SeriesInt from './SeriesInt';
import Toast from "../../../Forms/Toast";
import FeatureSummary from "../../../Util/FeatureSummary";
const header = css`
border-bottom: 1px solid #ededed;
    padding-bottom: 15px;
    h4{
        margin: 0 0 5px 0;
    }
`;

const newCoBrandSettingsObject = {
    client: '',
    cobrandTag: '',
    cobrand: '',
};

const featureSummary = [{
    selected: "0",
    label: "Selct Cobrand",
    summary:
        "First, choose specific clients, tags, and cobrands to manage their featured configurations.",
},
{
    selected: "1",
    label: "About Courses",
    summary:
        "Set the featured courses for the selected cobrand(s). You can add, remove, and reorder courses. They appear in the /courses page after required courses.",
    imageUrlPath: "featured-courses",
},
{
    selected: "2",
    label: "About Tools",
    summary:
        "Set the featured tools for the selected cobrand(s). You can add, remove, and reorder tools. They appear in the /tools page.",
    imageUrlPath: "featured-tools",
},
{
    selected: "3",
    label: "About Content",
    summary:
        "Set the featured content for the selected cobrand(s). You can add, remove, and reorder banners, videos, and other content items. They appear in the /topics page.",
    imageUrlPath: "featured-banner",
},
{
    selected: "4",
    label: "About Tags",
    summary:
        "Set the featured tags for the selected cobrand(s). You can add, remove, and reorder tags. They appear in the /topics page.",
    imageUrlPath: "featured-tags",
},
{
    selected: "5",
    label: "About Series",
    summary:
        "Sets the featured series that appears on the /topics page.",
    imageUrlPath: "featured-series",
},
{
    selected: "6",
    label: "About Series (Intl)",
    summary:
        "Sets the featured series that appears on the /topics page.",
    imageUrlPath: "featured-series",
},
{
    selected: "7",
    label: "About Financial Mindfulness",
    summary:
        "Sets the featured meditations that appears on the /meditations page.",
    imageUrlPath: "featured-meditations",
}]

const Featured = () => {
    const [selectedKey, setSelectedKey] = useState("0");
    const [cobrandList, setCobrandList] = useState([]);
    const [totalToUpdate, setTotalToUpdate] = useState(0);
    const [model, setModel] = useState({});
    const [edited, setEdited] = useState(false);
    const [unmatchedCobrand, setUnmatchedCobrand] = useState(false);
    const [showToast, setShowToast] = React.useState(false);

    const [{ data, loading }, getData] = useAxios(
        { url: 'internal/cobrand/featured-content', method: "post" },
        { manual: true }
    );
    const [{ data: saveedData, loadingSave }, saveData] = useAxios(
        { url: 'internal/cobrand/featured-content', method: "post" },
        { manual: true }
    );
    const handleLinkClick = (item) => {
        const itemKey = item.props.itemKey;
        setSelectedKey(itemKey);
    };

    const getDataClick = async () => {
        var result = await getData({
            data: cobrandList.map(x => x.coBrandId),
            method: "post",
            url: 'internal/cobrand/featured-content',
        });
        if (!result.isAxiosError) {
            setModel(result.data);
            setUnmatchedCobrand(cobrandList.length > 1 && result.data.notMatchedCobrand)
            setSelectedKey('1');
        }
    };


    const save = async () => {
        var m = model;
        m.CobrandResultData =cobrandList;
        var result = await saveData({
            data: m,
            method: "post",
            url: 'internal/cobrand/featured-update-all',
        });
        if (!result.isAxiosError) {
            setShowToast(true);
            setEdited(false);
        }
    };

    const saveIndividual = async (model, typeId) => {
        var result = await saveData({
            data: {
                CobrandResultData:cobrandList,
                items: model,
                ResourceTypeId:typeId
            },
            method: "post",
            url: 'internal/cobrand/featured-update-individual',
        });
        if (!result.isAxiosError) {
            setShowToast(true);
            setEdited(false);
        }
    };

    const moveItem = (key, index, direction) => {
        setEdited(true);
        setModel((prevModel) => {
            if (!prevModel[key]) return prevModel;
            const newItems = [...prevModel[key]];
            const newIndex = index + direction;
            if (newIndex >= 0 && newIndex < newItems.length) {
                [newItems[index], newItems[newIndex]] = [newItems[newIndex], newItems[index]];
            }

            return { ...prevModel, [key]: newItems };
        });
    };


    const addItem = (key, option) => {
        if (!option) return;
        setEdited(true);
        setModel((prevModel) => {
            if (!prevModel[key]) return prevModel;

            return {
                ...prevModel,
                [key]: [...prevModel[key], { id: option.value, name: option.label }],
            };
        });
    };

    const removeItem = (key, id) => {
        setEdited(true);
        setModel((prevModel) => {
            if (!prevModel[key]) return prevModel;

            return {
                ...prevModel,
                [key]: prevModel[key].filter((item) => item.id !== id),
            };
        });
    };

    return (
        <>
        <Formik
            initialValues={
                newCoBrandSettingsObject
            }
            isInitialValid={false}
        >
            {({ values }) => {
                const summaryObj = featureSummary.find(s => String(s.selected) === String(selectedKey));
                return (
                    <Form style={{ maxWidth: '1300px' }}>
                        <div css={header}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }} className="mt-1">
                                <h4>Featured Content</h4>
                                {!unmatchedCobrand && <PrimaryButton text="Save" disabled={!edited} onClick={save} />}
                            </div>

                            <span>Sections will only show cobrand available content if ONE cobrand is selected. If more than one cobrand is selected content will not be filterd.</span>
                            {unmatchedCobrand && <div style={{ marginTop: 10 }}><MessageBar messageBarType={MessageBarType.error} isMultiline={false}>{unmatchedCobrand} has features that do not match. Please update features individually</MessageBar></div>}
                        </div>
                        <div style={{ width: '100%' }} className="mt-1">
                            <Pivot selectedKey={selectedKey} onLinkClick={handleLinkClick}>
                                <PivotItem headerText="Select Cobrand" itemKey={'0'}>
                                    <SelectCobrandsForm  featured={true}/>
                                </PivotItem>
                                <PivotItem headerText="Courses" itemKey={'1'}>
                                    {selectedKey === "1" && <Courses
                                        moveItem={moveItem}
                                        addItem={addItem}
                                        removeItem={removeItem}
                                        saveIndividual={saveIndividual}
                                        showUpdateBtn={unmatchedCobrand}
                                        cobrandId={cobrandList.length > 1 ? null : cobrandList[0].coBrandId}
                                        model={model.crs} />}
                                </PivotItem>
                                <PivotItem headerText="Tools" itemKey={'2'}>
                                    {selectedKey === "2" && <Tools
                                        moveItem={moveItem}
                                        addItem={addItem}
                                        saveIndividual={saveIndividual}
                                        showUpdateBtn={unmatchedCobrand}
                                        removeItem={removeItem}
                                        cobrandId={cobrandList.length > 1 ? null : cobrandList[0].coBrandId}
                                        model={model.tools} />}
                                </PivotItem>
                                <PivotItem headerText="Content" itemKey={'3'}>
                                    {selectedKey === "3" && <Content
                                        moveItem={moveItem}
                                        addItem={addItem}
                                        saveIndividual={saveIndividual}
                                        showUpdateBtn={unmatchedCobrand}
                                        removeItem={removeItem}
                                        cobrandId={cobrandList.length > 1 ? null : cobrandList[0].coBrandId}
                                        model={model} />}
                                </PivotItem>
                                <PivotItem headerText="Tags" itemKey={'4'}>
                                    {selectedKey === "4" && <Tags
                                        moveItem={moveItem}
                                        addItem={addItem}
                                        saveIndividual={saveIndividual}
                                        showUpdateBtn={unmatchedCobrand}
                                        removeItem={removeItem}
                                        cobrandId={cobrandList.length > 1 ? null : cobrandList[0].coBrandId}
                                        model={model.tags} />}
                                </PivotItem>
                                <PivotItem headerText="Series" itemKey={'5'}>
                                    {selectedKey === "5" && <Series
                                        moveItem={moveItem}
                                        addItem={addItem}
                                        saveIndividual={saveIndividual}
                                        showUpdateBtn={unmatchedCobrand}
                                        removeItem={removeItem}
                                        cobrandId={cobrandList.length > 1 ? null : cobrandList[0].coBrandId}
                                        model={model.series} />}
                                </PivotItem>
                                <PivotItem headerText="Series (Intl)" itemKey={'6'}>
                                    {selectedKey === "6" && <SeriesInt
                                        moveItem={moveItem}
                                        addItem={addItem}
                                        saveIndividual={saveIndividual}
                                        showUpdateBtn={unmatchedCobrand}
                                        removeItem={removeItem}
                                        cobrandId={cobrandList.length > 1 ? null : cobrandList[0].coBrandId}
                                        model={model.seriesIntl} />}
                                </PivotItem>
                                <PivotItem headerText="Financial Mindfulness" itemKey={'7'}>
                                    {selectedKey === "7" && <FinancialMindfulness
                                        moveItem={moveItem}
                                        addItem={addItem}
                                        saveIndividual={saveIndividual}
                                        showUpdateBtn={unmatchedCobrand}
                                        removeItem={removeItem}
                                        cobrandId={cobrandList.length > 1 ? null : cobrandList[0].coBrandId}
                                        model={model.mindfulness} />}
                                </PivotItem>
                            </Pivot>
                            <hr />
                            {selectedKey === "0" && (<div style={{ display: 'flex', justifyContent: 'space-between' }} className="mt-1">
                                <PrimaryButton text="Select" onClick={getDataClick} />
                            </div>)}
                        </div>

                        {selectedKey === "0" && (
                            <ShowCobrandList
                                clients={values.client}
                                tags={values.cobrandTag}
                                cobrands={values.cobrand}
                                setParentCobrandList={setCobrandList}
                                setTotalToUpdate={setTotalToUpdate}
                            />
                        )}
                         {summaryObj && (
                            <FeatureSummary
                                label={summaryObj.label}
                                summary={summaryObj.summary}
                                imageUrlPath={summaryObj.imageUrlPath}
                            />
                        )}
                    </Form>
                );
            }}
                        
        </Formik>
        <Toast show={showToast} message="Saved!" onClose={()=>setShowToast(false)}/>
        </>
    );
};

export default Featured;
